import { Observable, Subscription } from 'rxjs';

export class CommandRelay<C> {
	private subscription: Subscription | null = null;
	
	constructor(
		private commandConsumer: (commandData: C) => void 
	) {
		
	}
	
	public register(obs: Observable<C> | null | undefined) {
		if (this.subscription) {
			this.subscription.unsubscribe();
			this.subscription = null;
		}
		if (obs) {
			this.subscription = obs.subscribe(
				(commandData: C) => this.commandConsumer(commandData)
			);
		}
	}
}